import script from "./ProductContentsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductContentsView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__